import React from 'react';
import classnames from 'classnames';
import './HeatmapDiagRasterSuccessScreen.css';

const RETRIEVE_SUCCESS_MESSAGE = 'The Diagnostic Raster has been  completed.';

const HeatmapDiagRasterSuccessScreen = (props) => {
  return (
    <div id="HeatmapDiagRasterSuccessScreen_Container" className="HeatmapDiagRasterSuccessScreen_Container">
      <div id="HeatmapDiagRasterSuccessScreen_TopContainer" className="HeatmapDiagRasterSuccessScreen_TopContainer">
        <div id="HeatmapDiagRasterSuccessScreen_HeaderText" className="HeatmapDiagRasterSuccessScreen_HeaderText">
          Success!
        </div>
        <div
          id="HeatmapDiagRasterSuccessScreen_MessageText"
          className="HeatmapDiagRasterSuccessScreen_MessageText"
          data-tip={RETRIEVE_SUCCESS_MESSAGE}
        >
          {RETRIEVE_SUCCESS_MESSAGE}
        </div>
      </div>
      <div id="HeatmapDiagRasterSuccessScreen_BottomContainer" className="HeatmapDiagRasterSuccessScreen_BottomContainer">
        <button
          id="HeatmapDiagRasterSuccessScreen_Bottom_CancelButton"
          className={classnames({
            HeatmapDiagRasterSuccessScreen_Bottom_CancelButton: true
            // HeatmapDiagRasterSuccessScreen_Bottom_CancelButton_Disabled: isFetching
          })}
          onClick={() => {
            props.onClose();
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default React.memo(HeatmapDiagRasterSuccessScreen);
